import { Bell, Search } from 'lucide-react';
import { NeonButton } from '../design/NeonButton';

export const Header = () => {
  return (
    <header className="sticky top-0 z-40 h-20 px-8 flex items-center justify-between glass border-b border-white/5">
      <div className="flex items-center gap-4">
        {/* Mobile menu trigger could go here */}
        <h2 className="text-xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-white to-white/60">
          Overview
        </h2>
      </div>

      <div className="flex items-center gap-4">
        <div className="relative hidden md:block group">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground group-focus-within:text-primary transition-colors" />
          <input 
            type="text" 
            placeholder="Search anything..." 
            className="h-10 w-64 bg-secondary/50 border border-white/10 rounded-full pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
          />
        </div>

        <button className="relative w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors">
          <Bell className="w-5 h-5 text-muted-foreground" />
          <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-red-500 shadow-neon" />
        </button>

        <NeonButton size="sm" variant="primary">
          + New Post
        </NeonButton>
      </div>
    </header>
  );
};
